var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',_vm._g(_vm._b({staticClass:"base-input",attrs:{"placeholder":"请输入"}},'el-input',_vm.$attrs,false),_vm.$listeners),[_vm._t("append",null,{"slot":"append"}),_vm._t("prefix",null,{"slot":"prefix"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }